"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../../createApi");

var GroupsApi = function (_BaseApi) {
  (0, _inherits2["default"])(GroupsApi, _BaseApi);

  function GroupsApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, GroupsApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(GroupsApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroups", function (_ref) {
      var groupId = _ref.groupId,
          childOf = _ref.childOf,
          code = _ref.code,
          clientId = _ref.clientId,
          skip = _ref.skip,
          limit = _ref.limit;
      return _this.api.get('/groups', {
        withoutAuth: true,
        params: {
          _id: groupId,
          childOf: childOf,
          code: code,
          clientId: clientId,
          skip: skip,
          limit: limit
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupsByIds", function (_ref2) {
      var ids = _ref2.ids,
          clientId = _ref2.clientId,
          _ref2$skip = _ref2.skip,
          skip = _ref2$skip === void 0 ? 0 : _ref2$skip,
          _ref2$limit = _ref2.limit,
          limit = _ref2$limit === void 0 ? 20 : _ref2$limit;
      var groupIds = ids.map(function (id) {
        return "ids=".concat(id);
      }).join('&');
      return _this.api.get("/groups/ids?".concat(groupIds), {
        params: {
          clientId: clientId,
          skip: skip,
          limit: limit
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroup", function (_ref3) {
      var groupId = _ref3.groupId,
          clientId = _ref3.clientId,
          withHierarchy = _ref3.withHierarchy,
          withSubGroup = _ref3.withSubGroup,
          search = _ref3.search,
          skip = _ref3.skip,
          limit = _ref3.limit,
          token = _ref3.token;
      return _this.api.get("/groups/".concat(groupId), {
        params: {
          clientId: clientId,
          withHierarchy: withHierarchy,
          withSubGroup: withSubGroup,
          search: search,
          skip: skip,
          limit: limit
        },
        headers: token ? {
          Authorization: token
        } : {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupUsers", function (_ref4) {
      var clientId = _ref4.clientId,
          groupId = _ref4.groupId,
          skip = _ref4.skip,
          limit = _ref4.limit,
          sort = _ref4.sort,
          search = _ref4.search;
      return _this.api.get("/groups/".concat(groupId, "/users"), {
        params: {
          clientId: clientId,
          skip: skip,
          limit: limit,
          sort: sort,
          search: search
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getParentGroupsFromClient", function (_ref5) {
      var clientId = _ref5.clientId,
          skip = _ref5.skip,
          limit = _ref5.limit,
          sort = _ref5.sort,
          isActive = _ref5.isActive,
          search = _ref5.search;
      return _this.api.get('/groups/parents', {
        withoutAuth: false,
        params: {
          clientId: clientId,
          skip: skip,
          limit: limit,
          sort: sort,
          isActive: isActive,
          search: search
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createGroup", function (_ref6) {
      var clientId = _ref6.clientId,
          _ref6$shouldInitRanki = _ref6.shouldInitRanking,
          shouldInitRanking = _ref6$shouldInitRanki === void 0 ? false : _ref6$shouldInitRanki,
          _ref6$shouldEmitIdent = _ref6.shouldEmitIdentify,
          shouldEmitIdentify = _ref6$shouldEmitIdent === void 0 ? false : _ref6$shouldEmitIdent,
          data = _ref6.data;
      return _this.api.post("/groups", {
        data: data,
        params: {
          clientId: clientId,
          shouldInitRanking: shouldInitRanking,
          shouldEmitIdentify: shouldEmitIdentify
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOneResourceGroup", function (_ref7) {
      var resourceId = _ref7.resourceId,
          resourceType = _ref7.resourceType,
          id = _ref7.id,
          _ref7$withMembers = _ref7.withMembers,
          withMembers = _ref7$withMembers === void 0 ? false : _ref7$withMembers,
          clientId = _ref7.clientId;
      return _this.api.get("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/").concat(id), {
        params: {
          withMembers: withMembers,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getResourceGroups", function (_ref8) {
      var resourceId = _ref8.resourceId,
          resourceType = _ref8.resourceType,
          clientId = _ref8.clientId,
          limit = _ref8.limit,
          skip = _ref8.skip,
          code = _ref8.code,
          category = _ref8.category,
          withMembers = _ref8.withMembers,
          filterOpenGroups = _ref8.filterOpenGroups;
      return _this.api.get("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId), {
        params: {
          limit: limit,
          skip: skip,
          client: clientId,
          code: code,
          category: category,
          withMembers: withMembers,
          filterOpenGroups: filterOpenGroups
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "searchResourceGroups", function (_ref9) {
      var resourceId = _ref9.resourceId,
          resourceType = _ref9.resourceType,
          clientId = _ref9.clientId,
          limit = _ref9.limit,
          skip = _ref9.skip,
          code = _ref9.code,
          category = _ref9.category,
          withMembers = _ref9.withMembers,
          filterOpenGroups = _ref9.filterOpenGroups,
          search = _ref9.search;
      return _this.api.get("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/search"), {
        params: {
          limit: limit,
          skip: skip,
          client: clientId,
          code: code,
          category: category,
          withMembers: withMembers,
          filterOpenGroups: filterOpenGroups,
          search: search
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createResourceGroup", function (_ref10) {
      var clientId = _ref10.clientId,
          data = _ref10.data,
          resourceType = _ref10.resourceType,
          resourceId = _ref10.resourceId;
      return _this.api.post("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId), {
        data: data,
        params: {
          client: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editGroup", function (_ref11) {
      var clientId = _ref11.clientId,
          groupId = _ref11.groupId,
          data = _ref11.data;
      return _this.api.put("/groups/".concat(groupId), {
        data: data,
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteGroup", function (_ref12) {
      var clientId = _ref12.clientId,
          groupId = _ref12.groupId,
          _ref12$withUsersClien = _ref12.withUsersClients,
          withUsersClients = _ref12$withUsersClien === void 0 ? false : _ref12$withUsersClien;
      return _this.api["delete"]("/groups/".concat(groupId), {
        params: {
          withUsersClients: withUsersClients,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "importGroups", function (_ref13) {
      var clientId = _ref13.clientId,
          topParentId = _ref13.topParentId,
          data = _ref13.data;
      var isFormData = data instanceof FormData;
      return _this.api.post("/groups/import", {
        headers: isFormData ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        data: data,
        params: {
          clientId: clientId,
          topParentId: topParentId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "joinResourceGroup", function (_ref14) {
      var groupId = _ref14.groupId,
          resourceType = _ref14.resourceType,
          clientId = _ref14.clientId,
          userId = _ref14.userId,
          source = _ref14.source,
          code = _ref14.code;
      return _this.api.post("/users/".concat(userId, "/groups/").concat(groupId, "/resourceType/").concat(resourceType, "/join"), {
        params: {
          clientId: clientId,
          source: source,
          code: code
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getRandomResourceGroup", function (_ref15) {
      var resourceType = _ref15.resourceType,
          resourceId = _ref15.resourceId,
          clientId = _ref15.clientId;
      return _this.api.get("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/random"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "countResourceGroups", function (_ref16) {
      var resourceId = _ref16.resourceId,
          resourceType = _ref16.resourceType,
          clientId = _ref16.clientId;
      return _this.api.get("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/count"), {
        params: {
          client: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editResourceGroup", function (_ref17) {
      var clientId = _ref17.clientId,
          data = _ref17.data,
          groupId = _ref17.groupId,
          resourceType = _ref17.resourceType,
          resourceId = _ref17.resourceId;
      return _this.api.put("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/").concat(groupId), {
        data: data,
        params: {
          client: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteResourceGroup", function (_ref18) {
      var resourceType = _ref18.resourceType,
          resourceId = _ref18.resourceId,
          clientId = _ref18.clientId,
          groupId = _ref18.groupId;
      return _this.api["delete"]("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/").concat(groupId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getResourceGroupMembers", function (_ref19) {
      var resourceId = _ref19.resourceId,
          resourceType = _ref19.resourceType,
          groupId = _ref19.groupId,
          clientId = _ref19.clientId,
          limit = _ref19.limit,
          skip = _ref19.skip;
      return _this.api.get("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/").concat(groupId, "/members"), {
        params: {
          limit: limit,
          skip: skip,
          client: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addMembersInBatchToResourceGroup", function (_ref20) {
      var resourceId = _ref20.resourceId,
          resourceType = _ref20.resourceType,
          groupId = _ref20.groupId,
          clientId = _ref20.clientId,
          userIds = _ref20.userIds;
      return _this.api.post("/groups/resourceType/".concat(resourceType, "/resourceId/").concat(resourceId, "/").concat(groupId, "/members"), {
        data: {
          userIds: userIds
        },
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getResourceGroupByUser", function (_ref21) {
      var resourceId = _ref21.resourceId,
          resourceType = _ref21.resourceType,
          userId = _ref21.userId,
          clientId = _ref21.clientId,
          limit = _ref21.limit,
          sort = _ref21.sort,
          skip = _ref21.skip;
      return _this.api.get("/users/".concat(userId, "/groups/resourceType/").concat(resourceType, "/resourceId/").concat(resourceId), {
        params: {
          client: clientId,
          sort: sort,
          limit: limit,
          skip: skip
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAllResourceGroupByUser", function (_ref22) {
      var resourceId = _ref22.resourceId,
          resourceType = _ref22.resourceType,
          userId = _ref22.userId,
          clientId = _ref22.clientId,
          sort = _ref22.sort;
      return _this.api.get("/users/".concat(userId, "/groups/resourceType/").concat(resourceType, "/resourceId/").concat(resourceId), {
        params: {
          client: clientId,
          sort: sort
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "searchResourceGroupByUser", function (_ref23) {
      var resourceId = _ref23.resourceId,
          resourceType = _ref23.resourceType,
          userId = _ref23.userId,
          clientId = _ref23.clientId,
          search = _ref23.search,
          limit = _ref23.limit,
          skip = _ref23.skip,
          sort = _ref23.sort;
      return _this.api.get("/users/".concat(userId, "/groups/resourceType/").concat(resourceType, "/resourceId/").concat(resourceId, "/search"), {
        params: {
          client: clientId,
          search: search,
          limit: limit,
          skip: skip,
          sort: sort
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUnregisteredResourceGroupByUser", function (_ref24) {
      var resourceId = _ref24.resourceId,
          resourceType = _ref24.resourceType,
          userId = _ref24.userId,
          clientId = _ref24.clientId,
          limit = _ref24.limit,
          skip = _ref24.skip,
          sort = _ref24.sort;
      return _this.api.get("/users/".concat(userId, "/groups/resourceType/").concat(resourceType, "/resourceId/").concat(resourceId, "/unregistered"), {
        params: {
          client: clientId,
          limit: limit,
          skip: skip,
          sort: sort
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "searchUnregisteredResourceGroupByUser", function (_ref25) {
      var resourceId = _ref25.resourceId,
          resourceType = _ref25.resourceType,
          userId = _ref25.userId,
          clientId = _ref25.clientId,
          search = _ref25.search,
          limit = _ref25.limit,
          skip = _ref25.skip,
          sort = _ref25.sort;
      return _this.api.get("/users/".concat(userId, "/groups/resourceType/").concat(resourceType, "/resourceId/").concat(resourceId, "/search-unregistered"), {
        params: {
          client: clientId,
          limit: limit,
          skip: skip,
          sort: sort,
          search: search
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "leaveResourceGroup", function (_ref26) {
      var groupId = _ref26.groupId,
          resourceType = _ref26.resourceType,
          clientId = _ref26.clientId,
          userId = _ref26.userId;
      return _this.api.post("/users/".concat(userId, "/groups/").concat(groupId, "/resourceType/").concat(resourceType, "/leave"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "switchTeams", function (payload) {
      return _this.api.put("/users-groups", {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "switchOneTeam", function (_ref27) {
      var clientId = _ref27.clientId,
          groupId = _ref27.groupId,
          userId = _ref27.userId;
      return _this.api.put("/users-groups/".concat(userId), {
        params: {
          clientId: clientId,
          groupId: groupId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupsLinkedToDomain", function (_ref28) {
      var clientId = _ref28.clientId;
      return _this.api.get("groups/domains", {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendInviteToGroup", function (_ref29) {
      var clientId = _ref29.clientId,
          userId = _ref29.userId,
          groupId = _ref29.groupId,
          deeplink = _ref29.deeplink;
      return _this.api.post("users/".concat(userId, "/groups/").concat(groupId, "/invite"), {
        params: {
          clientId: clientId,
          deeplink: deeplink
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendInviteFromCsv", function (_ref30) {
      var campaignId = _ref30.campaignId,
          deeplink = _ref30.deeplink,
          webPath = _ref30.webPath,
          clientId = _ref30.clientId,
          groupId = _ref30.groupId,
          data = _ref30.data,
          language = _ref30.language;
      var isFormData = data instanceof FormData;
      return _this.api.post("/invitations", {
        headers: isFormData ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        data: data,
        params: {
          campaignId: campaignId,
          deeplink: deeplink,
          webPath: webPath,
          clientId: clientId,
          groupId: groupId,
          language: language
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOneGroupByCode", function (_ref31) {
      var clientId = _ref31.clientId,
          code = _ref31.code,
          withSubGroup = _ref31.withSubGroup,
          search = _ref31.search,
          skip = _ref31.skip,
          limit = _ref31.limit,
          withHierarchy = _ref31.withHierarchy,
          withDirectChildren = _ref31.withDirectChildren;
      return _this.api.get("groups/code/".concat(code), {
        params: {
          clientId: clientId,
          withSubGroup: withSubGroup,
          search: search,
          skip: skip,
          limit: limit,
          withHierarchy: withHierarchy,
          withDirectChildren: withDirectChildren
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getInvitations", function (_ref32) {
      var clientId = _ref32.clientId,
          groupId = _ref32.groupId,
          status = _ref32.status,
          next = _ref32.next,
          email = _ref32.email,
          limit = _ref32.limit;
      return _this.api.get("invitations/", {
        params: {
          clientId: clientId,
          groupId: groupId,
          status: status,
          next: next,
          email: email,
          limit: limit
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUserResourceGroupRank", function (_ref33) {
      var rank = _ref33.rank,
          groupId = _ref33.groupId,
          userId = _ref33.userId,
          resourceType = _ref33.resourceType,
          clientId = _ref33.clientId;
      return _this.api.put("/users/".concat(userId, "/groups/").concat(groupId, "/resourceType/").concat(resourceType), {
        data: {
          rank: rank,
          clientId: clientId
        }
      });
    });
    return _this;
  }

  return GroupsApi;
}(_createApi.BaseApi);

var _default = GroupsApi;
exports["default"] = _default;
//# sourceMappingURL=index.js.map